export default __webpack_public_path__ + "static/media/sol.19b20fe8.svg";